var map = {
	"./building-strip.svg": 8481,
	"./developer-construction-site.svg": 9857,
	"./dots.svg": 8665,
	"./google_play_buttons.svg": 5424,
	"./homepage-image.svg": 1392,
	"./icons/arrow-forward.svg": 3041,
	"./icons/attachment.svg": 6612,
	"./icons/cash_in_circle_icon.svg": 7508,
	"./icons/icon-small.svg": 7436,
	"./icons/play-button-downloaded2.svg": 5794,
	"./icons/playButton.svg": 208,
	"./icons/playButtonDownloaded.svg": 7650,
	"./icons/search_icon_in_circle.svg": 3089,
	"./icons/sec_icon.svg": 5974,
	"./icons/send-icon.svg": 6419,
	"./icons/stock_going_up_icon.svg": 4836,
	"./icons/user_avatar_in_circle.svg": 1241,
	"./icons/whatsapp_icon.svg": 7771,
	"./independent_investment_committee.svg": 1930,
	"./lady-01.svg": 8990,
	"./lady-02.svg": 385,
	"./lady.svg": 3168,
	"./logo_clear.svg": 9545,
	"./looking-man.svg": 2851,
	"./man.svg": 5016,
	"./number_one_details.svg": 4458,
	"./number_three_details.svg": 1829,
	"./number_two_details.svg": 1786,
	"./numbers_labelling.svg": 1523,
	"./our_propcrowdy_dealroom.svg": 2203,
	"./strip-2.svg": 7570,
	"./zero_emission_graph.svg": 3048,
	"./zero_emission_icon.svg": 5028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9376;